import { Dispatch, SetStateAction } from 'react';
import { IAsyncType, useAsync } from '.';

import { CandidateProjectEventLogResponse } from '../../services/api';
import { InteractionTypeId } from '../../services/cadabraService';
import { cadabraService } from '../../services/services';

export interface IUserEventLogs<T> extends IAsyncType<T> {
  eventLogs: T;
  setEventLogs: Dispatch<SetStateAction<T>>;
}

const useUserEventLogs = (
  id: number,
  types: InteractionTypeId[] = [],
  fromDate?: string,
  toDate?: string,
  limit: number = 1000,
  skip: number = 0
): IUserEventLogs<CandidateProjectEventLogResponse[]> => {
  const { data, setData, loading, setLoading, parameters, setParameters } = useAsync<
    CandidateProjectEventLogResponse[]
  >(
    cadabraService.getCandidateProjectEventLogs,
    [],
    [[], [], [id], types, fromDate, toDate, limit, skip]
  );
  return {
    eventLogs: data,
    setEventLogs: setData,
    loading,
    setLoading,
    parameters,
    setParameters
  };
};

export default useUserEventLogs;
